export const selectRenewalPermitData = (state) => state.renew?.applicationData;
export const selectInitiatingRenewFlow = (state) => state.renew?.initiatingRenewFlow;
export const selectInitiatingRenewFlowError = (state) => state.renew?.initiatingRenewFlowError;
export const selectPermitRegistrant = (state) => state.renew?.applicationData?.registrant;
export const selectRenewLicenseInProgress = (state) => state.renew.renewLicenseInProgress;
export const selectRenewLicenseError = (state) => state.renew.renewLicenseError;
export const selectDocumentUploadStarted = (state) => state.renew?.documentUploadStarted;
export const selectDocumentUploadWorking = (state) => state.renew?.documentUploadWorking;
export const selectDocumentUploadCompleted = (state) => state.renew?.documentUploadCompleted;
export const selectDocumentUploadErrors = (state) => state.renew?.documentUploadErrors;
export const selectRenewApplicationNumber = (state) => state.renew?.applicationNumber;
export const selectRenewIsPaymentRequired = (state) => {
    const {
        fee,
        custom_fee,
        fee_override,
        custom_fee_multiple_answers
    } = state.config?.settings?.express?.registration?.renew;

    return (fee && fee !== 0) || custom_fee || fee_override || custom_fee_multiple_answers;
}
export const selectLateRenewalData = (state) => state.renew?.lateRenewalData;
export const selectSelectedBulkRenewalLicenses = (state) => state.renew?.selectedBulkRenewalLicenses;
